import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: e = 16, useVw: t, useRem: c, color: n, withColor: o, removeClassName: l, disableSSR: m, style: r, ...p }) => {
  const E = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-ETH20", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: E, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-ETH2.0"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: o ? d(n, 0, "#262933") : "#262933",
        datafollowfill: o ? d(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16.668 5.718a1.88 1.88 0 0 0-1.846.019L7.14 10.17a1.88 1.88 0 0 0-.94 1.63v8.521c0 .686.373 1.317.974 1.648l7.92 4.355a1.88 1.88 0 0 0 1.812 0l1.335-.734a.9.9 0 1 1 .868 1.577l-1.336.735a3.68 3.68 0 0 1-3.547 0l-7.92-4.356A3.68 3.68 0 0 1 4.4 20.32V11.8a3.68 3.68 0 0 1 1.84-3.188l7.683-4.434a3.68 3.68 0 0 1 3.613-.038l2.45 1.348a.933.933 0 0 1 .022.012l5.77 3.377a3.68 3.68 0 0 1 1.822 3.176V17.4a.9.9 0 0 1-1.8 0v-5.346a1.88 1.88 0 0 0-.93-1.623l-5.761-3.37-2.44-1.342Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M25.845 26.428c.25 0 .454.204.454.454v.516c0 .25-.203.454-.454.454h-3.869a.454.454 0 0 1-.453-.454v-.62a.45.45 0 0 1 .1-.284l2.866-3.573c.085-.106.15-.226.197-.36.049-.134.073-.27.073-.406a.872.872 0 0 0-.127-.464.853.853 0 0 0-.344-.325.98.98 0 0 0-.484-.12.984.984 0 0 0-.48.116.875.875 0 0 0-.46.778.159.159 0 0 1-.158.158h-1.071a.19.19 0 0 1-.19-.19 2.227 2.227 0 0 1 1.157-1.983c.36-.201.763-.302 1.206-.302.444 0 .846.1 1.207.302a2.228 2.228 0 0 1 1.16 1.984 2.771 2.771 0 0 1-.603 1.728l-2.073 2.591h2.346Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.782 10.419a.85.85 0 0 0-1.497-.01l-3.133 5.732a.85.85 0 0 0 .025.858l3.133 5.015a.85.85 0 0 0 1.444-.003l3.067-4.96a.85.85 0 0 0 .028-.845l-3.067-5.787Zm-.755 9.534-2.145-3.433 2.137-3.91 2.1 3.961-2.092 3.382Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
